import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import CheckboxInput from 'src/components/ui/CheckboxInput';
import { selectHasDisableUnityLoader, setHasDisableUnityLoader } from 'src/slices/upload.slice';

const GameOptionsModuleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    flex: 1 1 0%;
    border-radius: 0 0 8px 8px;
    padding: 16px;
    background: var(--surface);
`;

const GameOptionsContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    width: 100%;
    gap: 8px;
`;

const GameOptionsTitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

const GameOptionsTitle = styled.h2`
    margin: 0;
    font-size: 24px;
`;

const GameOptionsSubtitle = styled.h3`
    margin: 0;
    font-weight: 400;
    color: var(--text-secondary);
`;

export default function GameOptionsModule() {
    const dispatch = useDispatch();

    const hasDisableUnityLoader = useSelector(selectHasDisableUnityLoader);

    const handleDisableUnityLoaderChange = () => {
        dispatch(setHasDisableUnityLoader(!hasDisableUnityLoader));
    };

    return (
        <GameOptionsModuleWrapper>
            <GameOptionsTitleWrapper>
                <GameOptionsTitle>Game Upload Options</GameOptionsTitle>
                <GameOptionsSubtitle>
                    Configure options for uploading and testing your game.
                </GameOptionsSubtitle>
            </GameOptionsTitleWrapper>
            <GameOptionsContainer>
                <CheckboxInput
                    id="disable-unity-loader"
                    label="Disable Unity loader"
                    tooltip="If checked, the Unity loader will be disabled during game load. Only for Unity games."
                    checked={hasDisableUnityLoader}
                    onChange={handleDisableUnityLoaderChange}
                />
            </GameOptionsContainer>
        </GameOptionsModuleWrapper>
    );
}
